module.exports = __webpack_public_path__ + "media/testimonials/customer-7-3d435316.png";